import React,{ Component } from 'react';
import {isEmailValid, isStringEmpty} from "../../_helpers/string_helper";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import {loginService} from '../../services/login.service';
import { helperText } from '../../_helpers/helpertext';
import { historypush } from '../../_helpers/utilities';
import Loader from '../../_helpers/Loader';
import eye from "../../Images/eye.png";
import ForgotPassword from './Component/ForgotPassword';
import profileimage from "../../Images/profile.png";
import moment from "moment";

var now = new Date();
class login extends Component{
  constructor(props){
    super(props);
    this.state={
      emailAddress:'',
      password:'',
      grade:'',
      surname:'',
      memberCodeError: false,
      passwordError: false,
      surNameError:false,
      captchaError:false,
      slectedGrade:"Fellow",
      loginDetailsError:false,
      isLoading:false,
      showPassword: false,
      showModel:false,
    }
  }

  componentDidMount=()=>{
    loadCaptchaEnginge(6); 
    
  }

  doSubmit = () => {
    // <! --   let's assume there is an HTML input text box with id 'user_captcha_input' to get user input -->   
         let user_captcha_value = document.getElementById('user_captcha_input').value;
         if (validateCaptcha(user_captcha_value)===true) {
          this.setState({captchaError: "",});
          return false;
         }
         else {
             //alert('Captcha Does Not Match');
             this.setState({ captchaError: helperText.loginPageText.emptyCaptcha });
             return true;
         }
     };

  /* <summary>
  date: 30-05-2022
  Name: VD
  description: To check if the entered data is empty or not
  <summary>*/ 
  validate = async (e) => {
    e.preventDefault();
    
    const { emailAddress, password,surname } = this.state;
    let hasErrors = false;

    hasErrors=this.doSubmit();

    if (isStringEmpty(emailAddress)) {
        hasErrors = true;
        if(this.state.slectedGrade==="Student"){
          this.setState({ memberCodeError: helperText.loginPageText.emptyUserCodeError });
        }else{
          this.setState({ memberCodeError: helperText.loginPageText.emptymemberCodeError });
        }
        
    }else
        this.setState({memberCodeError: "",});

    if (isStringEmpty(password)) {
        hasErrors = true;
        this.setState({passwordError: helperText.loginPageText.emptyPasswordError,});
    } else{
        this.setState({passwordError: "",});
    }

    if(this.state.slectedGrade==="Student"){

    }else{
      if (isStringEmpty(surname)) {
        hasErrors = true;
        this.setState({surNameError: helperText.loginPageText.emptySurNameError,});
      } else{
        this.setState({surNameError: "",});
      }
    }
    if (hasErrors) return;

    this.GetLoginInfo();
  };

  /* <summary>
  date: 30-05-2022
  Name: VD
  description: To get the user login details check if he can login or not
  <summary>*/ 
  GetLoginInfo=async()=>{
    try{
      const { emailAddress, password,surname,slectedGrade } = this.state;
      this.setState({ isLoading: true });
      var response = await loginService.Login(emailAddress,password,surname,slectedGrade);
      if (response.status === 200) {
        if (response.data === "") {
          this.setState({
            loginDetailsError: helperText.loginPageText.wrongLoginDetails,
            isLoading: false
          });
        }else if(response.data == "Wrong Grade"){
          this.setState({
            loginDetailsError: helperText.loginPageText.wrongGradeSelected,
            isLoading: false
          })
        }else {
          localStorage.setItem("SessionToken", response.data.jwtToken);
          localStorage.setItem("UserName", response.data.userName);
          localStorage.setItem("UserID", response.data.userID);
          localStorage.setItem("Code", emailAddress);
          localStorage.setItem("Grade", slectedGrade);
          localStorage.setItem("SessionTimeout",moment(now).format('H:mm:ss a'))
          if(response.data.profileURL != null){
            localStorage.setItem("Profileurl", response.data.profileURL);
          }else{
            localStorage.setItem("Profileurl", profileimage);
          }
          localStorage.setItem("RoleId", response.data.roleId);
          
          //history.push('/dashboard');
          if(response.data.roleId === 1 || response.data.roleId === 4){
            historypush('/admindashboard');
          }else{
            if(response.data.roleId === 2){
              historypush('/tarbook');
            }else{
              historypush('/memberportal');
            }
          }
          //alert("Logged in");
          // window.location.href ="/wpreact/pro/"
          
        }
        
              
      } else {
        alert("Unable to connect to the Database");
        this.setState({ isLoading: false, });
      }
    }catch(er){
     return ""; 
    }
  }

  onTextChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      memberCodeError: false,
      passwordError: false,
      surNameError: false,
      captchaError: false,
      loginDetailsError:false,
      resetEmailError: false,
    });
  };

  OnEventChange(event) {
    this.setState({
        slectedGrade: event.target.value,
        memberCodeError: false,
        passwordError: false,
        surNameError: false,
        captchaError: false,
        loginDetailsError:false,
      },
      async () => {
        this.showHideRows();
      });
  }

  showHideRows=()=>{
    if(this.state.slectedGrade === "Student"){

    }
  }

  toggleEye = () => {
    const currentState = this.state.showPassword;
    this.setState({ showPassword: !currentState });
  };

  showForgotPasswordModel=()=>{
    this.setState({
      showModel:true,
    })
  }

  closeForgotPasswordModel=()=>{
    this.setState({
      showModel:false,
    })
  }

    render(){
      const {
        emailAddress,
        password,
        surname,
        memberCodeError,
        passwordError,
        surNameError,
        captchaError,
        slectedGrade,
        loginDetailsError,
        isLoading,
        showPassword,
        showModel,
    } = this.state;
        return(
            <div>
            {/* <div className='login-bacground' style={{backgroundColor:"#182b49"}}       > 
            <div className="hero">
              <div className="hero-box">
                <h2 style={{paddingBottom:"1rem"}}>{slectedGrade==="Student"?"USER PORTAL":"MEMBER PORTAL"}</h2>
                <p>Welcome to IMEI Memeber Portal</p>
              </div>
            </div>
            </div> */}
            <div className="container">
              {isLoading && <Loader />}
		      <form>
            <div className="Login-form">
              <h5>{slectedGrade==="Student"?"":"Welcome to IME(I) Member's Portal"}</h5>
              <h2>{slectedGrade==="Student"?"User Login":"Member Login"}</h2>
              <hr className="hr1" />
              <div className="mb-2">
                <label htmlFor="grade">Grade:</label>
                <select 
                  className="form-select form-select-lg mb-3" 
                  aria-label=".form-select-lg example"
                  value={slectedGrade}
                  onChange={this.OnEventChange.bind(this)}
                >
                  <option value={"Fellow"}>Fellow</option>
                  <option value={"Member"}>Member</option>
                  <option value={"Associate Member"}>Associate Member</option>
                  <option value={"Associate"}>Associate</option>
                  <option value={"Graduate"}>Graduate</option>
                  <option value={"Subscriber"}>Subscriber</option>
                  <option value={"Student"}>Student</option>
                </select>
              </div>
              <div className="mb-2">
                <label htmlFor="Code">{slectedGrade==="Student"?"User Code:":"Member Code:"}</label>
                <input type="text" className="form-control" 
                  name="emailAddress"  
                  value={emailAddress}   
                  onChange={this.onTextChange} 
                  style={{margin:'0px'}}
                />
                {!isStringEmpty(memberCodeError) && (
                                    <small
                                        id="emailHelp"
                                        className="form-text"
                                        style={{ color: "red" }}
                                    >
                                        {memberCodeError}
                                    </small>
                                )}
              </div>
              <div className="mb-2">
                <label htmlFor="pwd">Password:</label>
                <input 
                  type={showPassword ? "text" : "password"} 
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={this.onTextChange}
                  style={{margin:'0px'}}
                />
                <img
                  style={{ marginLeft: "90%", marginTop: "-65px",cursor :'pointer' }}
                  src={eye}
                  onClick={this.toggleEye}
                />
                {!isStringEmpty(passwordError) && (
                                    <small
                                        id="emailHelp"
                                        className="form-text"
                                        style={{ color: "red" }}
                                    >
                                        {passwordError}
                                    </small>
                                )}
              </div>
              {slectedGrade==="Student"?"":
              <div className="mb-2">
                <label htmlFor="surname">Surname:</label>
                <input type="text" className="form-control"
                  name="surname"
                  value={surname}
                  onChange={this.onTextChange}
                  style={{margin:'0px'}}
                />
                {!isStringEmpty(surNameError) && (
                                    <small
                                        id="emailHelp"
                                        className="form-text"
                                        style={{ color: "red" }}
                                    >
                                        {surNameError}
                                    </small>
                                )}
              </div>
              }
              <div className="mb-2">
                <div id="captchaBackground">
                  {/* <img src={captcha} />Captcha Text
                  <input id="textBox" className="form-control" type="text" name="text" />
                  <button id="refreshButton" type="submit">Refresh</button>
                  <span id="output" /> */}
                  <LoadCanvasTemplate />
                  <input id="user_captcha_input" style={{marginBottom:'0px'}} className="form-control" type="text" name="captcha" />
                  {!isStringEmpty(captchaError) && (
                                    <small
                                        id="emailHelp"
                                        className="form-text"
                                        style={{ color: "red" }}
                                    >
                                        {captchaError}
                                    </small>
                                )}
                </div>
              </div>
              <div className="d-grid">
                <button 
                  type="submit" 
                  onClick={this.validate}  
                  className="btn btn-block Login-btn"
                >
                  LOGIN
                </button>
                {!isStringEmpty(loginDetailsError) && (
                                    <small
                                        id="emailHelp"
                                        className="form-text"
                                        style={{ color: "red" }}
                                    >
                                        {loginDetailsError}
                                    </small>
                                )}
              </div>
              <p className="mt-2 next-link">Forgot Password? <a href='#' data-bs-toggle="modal" style={{cursor:'pointer'}} onClick={()=>this.showForgotPasswordModel()} data-bs-target="#myModal">Click Here</a></p>
              <p className='mt-2 next-link'>You can Change Password or submit Change Request after logging in and clicking on your Profile</p>
            </div>
          </form>
            {showModel && (
              <ForgotPassword
              clearforgotpassemail={this.closeForgotPasswordModel}
              />
            )}
          </div>
            </div>
        )
    }
}

export default login;